import CallbackNotifier from 'common/notifiers/callback';
import finalizeEmbeddedFlow from './finalize-embedded-flow';

const commands = {
  finalizeEmbeddedFlow,
};

export default {
  create(app) {
    app.notifier.push(
      CallbackNotifier.create((message) => {
        if (commands[message.type]) {
          return commands[message.type](message);
        }
      }),
    );
  },
};
